import { createActions } from 'redux-actions';

import { ENDPOINTS_MESSAGES } from '../../config/';
import { AnnouncementsDataProps } from '../../reducers/DashboardReducer/AnnouncementsReducer/AnnouncementsReducer.types';
import { defaultErrorMessage, globalFetch, isAction } from '../../shared/helpers/fetch-helper';
import { logErrorService } from '../../shared/services';

export const { dashboardAnnouncementsResponse, dashboardAnnouncementsRequest, dashboardAnnouncementsResponseFailure } = createActions(
  {
    DASHBOARD_ANNOUNCEMENTS_RESPONSE: (data: AnnouncementsDataProps) => ({ data }),
  },
  'DASHBOARD_ANNOUNCEMENTS_REQUEST',
  'DASHBOARD_ANNOUNCEMENTS_RESPONSE_FAILURE'
);

export function getLastAnnouncements(limit: number = 5) {
  return async (dispatch: any, getState: any): Promise<object> => {
    const state = getState();

    if (state.getIn(['dashboard', 'announcements', 'isfetching']) === true) {
      return dispatch(dashboardAnnouncementsRequest());
    }

    dispatch(dashboardAnnouncementsRequest());

    return globalFetch(
      `${ENDPOINTS_MESSAGES.messages}/self/messages?order=-dateCreated&limit=${limit}&type=ANNOUNCEMENT`,
      {
        method: 'GET',
        credentials: 'include',
      },
      dispatch,
      () => dispatch(dashboardAnnouncementsResponseFailure())
    )
      .then(async (json: any): Promise<object> => {
        if (isAction(json, 'DASHBOARD_ANNOUNCEMENTS_RESPONSE_FAILURE')) {
          return json;
        } else {
          return dispatch(dashboardAnnouncementsResponse(json));
        }
      })
      .catch((err: any) => {
        logErrorService(err, err);
        defaultErrorMessage(dispatch);

        return dispatch(dashboardAnnouncementsResponseFailure());
      });
  };
}
